import * as React from "react"
import { CollectionSearch } from "./collection-search"
import type { CollectionSearchProps } from "./types"

export interface MatterSearchProps
  extends Omit<CollectionSearchProps, "collection" | "displayMode"> {
  /** Additional filter beyond default matter filtering */
  filter?: Record<string, any>
}

/**
 * MatterSearch - Pre-configured CollectionSearch for matters.
 *
 * @example
 * <MatterSearch
 *   value={matterId}
 *   onChange={(option) => setMatterId(option?.value || null)}
 *   placeholder="Search matters..."
 * />
 *
 * @example
 * // With division filter
 * <MatterSearch
 *   value={matterId}
 *   onChange={(option) => setMatterId(option?.value || null)}
 *   filter={{ division: divisionId }}
 *   label="Select a matter"
 * />
 */
export function MatterSearch({
  placeholder = "Search matters...",
  ...props
}: MatterSearchProps) {
  return (
    <CollectionSearch
      {...props}
      collection="matters"
      displayMode="default"
      placeholder={placeholder}
    />
  )
}
